import React, { Component } from 'react';
import { FiFileText, FiEdit3 } from 'react-icons/fi';

const ServiceList = [
  {
    icon: <FiFileText />,
    title: 'Contracts',
    description: 'Explore the contracts of Volta Club.',
    target: '',
    link: '/contracts',
  },
  {
    icon: <FiEdit3 />,
    title: 'Latest Articles',
    description: 'Stay updated with our latest articles.',
    target: '_blank',
    link: 'https://medium.com/volta-newsletter/',
  },
];

class ServiceTwo extends Component {
  render() {
    let title = 'Information',
      description = 'Learn more about Volta Club.';
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-lg-4 col-12">
            <div className="section-title mt--30 mt_md--5 mt_mobile--5 mb_mobile--10">
              <h2 className="title">{title}</h2>
              <p>{description}</p>
              <div className="service-btn">
                <a
                  className="btn-transparent rn-btn-dark"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://discord.com/invite/voltaclub"
                >
                  <span className="text">Join our Discord!</span>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-12 mt_md--50">
            <div className="row service-one-wrapper">
              {ServiceList.map((val, i) => (
                <div className="col-lg-6 col-md-6 col-sm-6 col-12" key={i}>
                  <a
                    target={val.target}
                    rel="noopener noreferrer"
                    href={val.link}
                  >
                    <div className="service service__style--2">
                      <div className="icon">{val.icon}</div>
                      <div className="content">
                        <h3 className="title">{val.title}</h3>
                        <p>{val.description}</p>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default ServiceTwo;
